// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/* Variables */\n[data-v-ba0432f0]:export {\n  menuBg: #b58643;\n  menuText: #e0e0e0;\n  menuActiveText: #ffe164;\n  menuActiveBg: #906a35;\n}\n\n/* Mixins */\n.edit-input[data-v-ba0432f0] {\n  padding-right: 100px;\n}\n.cancel-btn[data-v-ba0432f0] {\n  position: absolute;\n  right: 15px;\n  top: 10px;\n}", ""]);
// Exports
module.exports = exports;
